import { useSession as useNextAuthSession } from "next-auth/react";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import {
  getCookieValue,
  removeCookieValue,
  setCookieValue,
} from "@/app/utils/utility";

export default function useSession() {
  const session = useNextAuthSession();
  const router = useRouter();

  useEffect(() => {
    if (session?.data?.accessToken) {
      setCookieValue("accessToken", session?.data?.accessToken, 7);
    }

    if (
      getCookieValue("accessToken") &&
      getCookieValue("checkout-redirect-status")
    ) {
      router.push("/checkout");
      removeCookieValue("checkout-redirect-status");
      return;
    }
  }, [session]);
}
